// Widget Scripts
import swiperWidget from './js/widgets/swiperWidget.js';
import cardWidgetFooterImages from './js/widgets/cardWidgetFooterImages.js';
import tierTwoParagraph from './js/widgets/tierTwoParagraph.js';
import cardWidgetTiles from './js/widgets/cardWidgetTiles.js';
import cssSponsors from './js/widgets/cssSponsors.js';
import { instafeed, facebookfeed } from './js/widgets/socialNetworkWidget.js';

// Custom Theme Scripts
import './js/localjs.js';
import tierTwoImages from './js/widgets/tierTwoImages.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    swiperWidget();
    tierTwoImages();
    tierTwoParagraph();
    cardWidgetTiles(); 
    cssSponsors();
    instafeed();
    facebookfeed(true);
  });
}

$(document).ready(function() {
  cardWidgetFooterImages(); // footer card widget
});